import { AppointmentMode } from '__generated__/globalTypes';

export const appointmentModeMap = {
  [AppointmentMode.PHONE]: 'phone',
  [AppointmentMode.VIDEO]: 'video',
} as const;
